export default "__VITE_ASSET__BPHsDiXr__"